// extracted by mini-css-extract-plugin
export var background = "NewsletterPopup-module--background--081cc";
export var close = "NewsletterPopup-module--close--f4512";
export var content = "NewsletterPopup-module--content--a5653";
export var left = "NewsletterPopup-module--left--7f537";
export var newsletterPopup = "NewsletterPopup-module--newsletter-popup--f3a57";
export var right = "NewsletterPopup-module--right--93f77";
export var text = "NewsletterPopup-module--text--7310b";
export var title = "NewsletterPopup-module--title--08ee9";